<template>
  <w-icon-wrapper
    icon-name='work-document-icon'
    :width='20'
    :height='24'
    view-box='0 0 20 24'
  >
    <g
      id="_16_Dokument_Icon"
      data-name="16 Dokument_Icon"
      transform="translate(-2)"
    >
      <path
        id="Pfad_55667"
        data-name="Pfad 55667"
        d="M16,0H2V24H22V6Zm0,2.828L19.172,6H16ZM4,22V2H14V8h6V22Z"
        fill="currentColor"
      />
      <path
        id="Pfad_55668"
        data-name="Pfad 55668"
        d="M7,8h4a1,1,0,0,0,0-2H7A1,1,0,0,0,7,8Z"
        fill="currentColor"
      />
      <path
        id="Pfad_55669"
        data-name="Pfad 55669"
        d="M16,10H7a1,1,0,0,0,0,2h9a1,1,0,0,0,0-2Z"
        fill="currentColor"
      />
      <path
        id="Pfad_55670"
        data-name="Pfad 55670"
        d="M16,14H7a1,1,0,0,0,0,2h9a1,1,0,0,0,0-2Z"
        fill="currentColor"
      />
      <path
        id="Pfad_55671"
        data-name="Pfad 55671"
        d="M16,18H7a1,1,0,0,0,0,2h9a1,1,0,0,0,0-2Z"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconDocument' };
</script>
